import React from 'react';

import { Button } from '../../../../shadcn/Button';
import Link from '../../../../tailwind/Link';
import { getCollectionLink } from '../../../../../utils/getLink';
import GradientImage from './GradientImage';
import menuCollectionSorter from '../../../layout/Header/menuCollectionSorter';

interface Props {
  activeItem: {
    title?: string;
    ctaText?: string;
    items?: {
      title?: string;
    }[];
    collection?: {
      _id?: string;
      store?: {
        title?: string;
        slug?: {
          current?: string;
        };
      };
    };
    moments?: any[];
    childCollections?: {
      _id?: string;
      store?: {
        title?: string;
      };
    }[];
  };
}

export default function Collection({ activeItem }: Readonly<Props>) {
  return (
    <div className="ps-6 pe-6 md:ps-10 md:pe-10 lg:ps-20 lg:pe-20 2xl:ps-32 2xl:pe-32">
      <div className="gallery grid grid-cols-6 lg:grid-cols-12 gap-x-4 md:gap-x-6 gap-y-4 md:gap-y-6">
        <div className="col-span-3 h-full">
          <div className="flex flex-col space-y-4">
            {menuCollectionSorter(
              activeItem.collection?.store?.title,
              activeItem
            ).childCollections.map(cc => (
              <Link
                className="py-[6px] px-3 relative top-[2px] left-[2px] w-full text-left bg-transparent hover:bg-brand-foreground hover:text-secondary-foreground rounded-md transition-all duration-200 ease-in-out text-wrap"
                forceKeyboardNav
                key={cc?._id}
                link={getCollectionLink(cc?.store?.title)}
              >
                <span>{cc.store.title.split('/').slice(-1)[0]}</span>
              </Link>
            ))}
          </div>
          <div className="flex">
            <Button
              asChild
              className="block mt-2 whitespace-normal h-auto px-6 py-3"
              variant="primary"
            >
              <Link
                link={getCollectionLink(
                  activeItem?.collection?.store?.slug?.current
                )}
                className="text-base font-semibold"
              >
                {activeItem?.ctaText || activeItem?.title}
              </Link>
            </Button>
          </div>
        </div>
        {activeItem.moments?.length ? (
          <div
            className={`${
              activeItem?.moments?.length > 1 ? 'col-span-3' : 'col-span-9'
            }`}
          >
            <GradientImage
              image={activeItem.moments[0]?.image}
              link={activeItem.moments[0]?.link}
              headline={activeItem.moments[0]?.headline}
            />
          </div>
        ) : null}
        {activeItem.moments?.length > 1 ? (
          <div className="col-span-6">
            <div className="flex flex-col gap-4 h-full">
              <GradientImage
                image={activeItem.moments[1]?.image}
                link={activeItem.moments[1]?.link}
                headline={activeItem.moments[1]?.headline}
              />
              {activeItem.moments.length > 2 ? (
                <GradientImage
                  image={activeItem.moments[2]?.image}
                  link={activeItem.moments[2]?.link}
                  headline={activeItem.moments[2]?.headline}
                />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
